export default {
  // Endpoints
  userStatsEndpoint: 'user/stats',
  rankingEndpoint: 'ranking',
}
